import { FormRow } from '@ketch-com/deck'
import { RuleUpsert, RuleVariant } from 'pages/consentAndRights/deploymentPlans-v2/upsert/components/RuleUpsert'

/**
 * NOTE: WIP - this is stub component hidden behind a feature flag
 */

export const DeploymentPlanDefaultExperiences = () => {
  return (
    <FormRow
      title="Default Experiences"
      subTitle="These experiences apply to all current and future jurisdictions unless you override it in Custom Experience rules on the next step."
      hasTopBorder
    >
      <RuleUpsert variant={RuleVariant.Default} viewOnly={false} />
    </FormRow>
  )
}
